import { useContext } from "react";
import { ThemeContext } from "styled-components";
import BemIt, { addClass } from "@gtechdoodler/bem-it";

import StyledIcon from "./Icon.styles";
import { getIcon } from "./IconMapper";
import { IconColorVariants, IconProps } from "./Icon.types";

export const colorMapping: IconColorVariants = {
	accent: "cta_default",
	dark_1: "fg_dark_1",
	dark_2: "fg_dark_2",
	dark_3: "fg_dark_3",
	light_1: "fg_light_1",
	light_2: "fg_light_2",
	light_3: "fg_light_3",
	semantic_info: "semantic_info_600",
	semantic_success: "semantic_success_500",
	semantic_warning: "semantic_warning_400",
	semantic_error: "semantic_error_600",
};

const Icon: React.FC<IconProps> = ({
	className,
	name,
	size = "sm",
	color = "dark_1",
	variant = "icon-only",
	...props
}) => {
	const block = new BemIt("Icon");

	const themeContext = useContext(ThemeContext);

	const hasLightBackground = color.includes("light");
	const filledIconFill = hasLightBackground ? "dark_1" : "light_1";

	const colorToken = variant === "filled" ? filledIconFill : color;
	const fillValue = themeContext.palette.hexFor(colorMapping[colorToken]);

	return (
		<StyledIcon
			className={addClass(className).after(block.mod([size, variant]))}
			size={size}
			color={color}
			variant={variant}
			aria-label={`${name} icon`}
			{...props}
		>
			{getIcon(name, fillValue)}
		</StyledIcon>
	);
};

export default Icon;
